import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

/* theme css ( if any ) */

/* app css */
import "@shared/styles/index.scss"; // shared styles are temporarily imported here in root index, later need to ship them with their respected modules. #TODO
import "./index.css";
import configureStore from "@app/store/configureStore";

import { appUrlPrefix, isViewedOnGhPages, getNodeEnv } from "@shared/constants";
const store = configureStore();
import DataService from "@shared/services/DataService";
import DataStore from "@shared/services/DataStore";

// const App = lazy(() => import(/* webpackChunkName: "app" */ "@app")); // lazy(() => import("@app")); for unnamed chunks.
const App = lazy(() => import(/* webpackChunkName: "app" */ "@app")); // lazy(() => import("@app")); for unnamed chunks.

__webpack_public_path__ = `${window.CONST?.remoteJsUrl}/${window.CONST?.applicationBuildFolder}/`;

const Root = () => {
    return (
        <Provider store={store}>
            <BrowserRouter  {...(isViewedOnGhPages ? { basename: "/[repo]" } : {})}>
                {/* https://github.com/facebook/create-react-app/issues/1765 */}
                <RootRoutes />
            </BrowserRouter>
        </Provider>
    );
};

const RootRoutes = ({ location, ...rest }) => {
    return (
        <Suspense fallback={<div className="loading-inline" />}>
            <Switch>
                <Route path={appUrlPrefix} component={App} />

                <Route path="/" render={() => <Redirect to={appUrlPrefix} />} />
            </Switch>
        </Suspense>
    );
};

Promise.all([DataService.init(), DataStore.init()])
    .then(() => {
        const container = document.getElementById("app");
        const root = createRoot(container);
        root.render(<Root />);

        try {
            console.log(`
            ################################# CDN DETAILS #################################
            FILE :: /${window.CONST?.applicationBuildFolder}/main.bundle.js
            FROM :: ${window.CONST?.remoteJsUrl}
            VERSION :: ${_process.env.version || "-"}
            BUILD TIME :: ${_process.env.timestamp ? new Date(_process.env.timestamp) : "-"}
            SERVER :: ${window.CONST?.remoteServerUrl}
            ENV :: ${getNodeEnv() || "-"}
            ###############################################################################
        `);
        } catch (error) {
            console.error(error);
        }
    })
    .catch(() => console.error("App initiation failed!"));

    export { store };